import Flux from 'lib/flux';
import ContactService from 'services/contact';
import ContactConstants from 'constants/contact';

const ContactActionCreator = Flux.createActionCreator({
  sendMessage(message) {
    this.dispatchAction(ContactConstants.SEND_MESSAGE);
    ContactService.sendMessage(message).then(
      (_resp) => {
        this.dispatchAction(ContactConstants.SEND_MESSAGE_COMPLETED);
      },
      (_resp) => {
        const payload = { errors: { base: 'Something went wrong.' } };
        this.dispatchAction(ContactConstants.SEND_MESSAGE_FAILED, payload);
      }
    );
  },
});

export default ContactActionCreator;
